import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Figure,
  Form,
  Row,
} from "react-bootstrap";
import { sponsors } from "../../../components/shared/constraints";
import { getUsersApi } from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import { BASE_URL } from "../../../services/path";
import OPagination from "../../../components/shared/pagination/OPagination";
import { removeMultiSpace, textTruncateMore } from "../../../helper/helper";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";
import NoDataFound from "../../../components/shared/Loader/NoDataAnimation";
import { useNavigate } from "react-router-dom";

const MemberInfo = () => {
  const navigate = useNavigate();

  const notification = useToastContext();
  // ALL STATE
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [user, setUser] = useState([]);
  const [filterData, setFilterData] = useState({});

  const fetchedGetUsers = (data = {}) => {
    const requestPayload = { ...data };
    getUsersApi(requestPayload, notification, (loading, error, response) => {
      setLoader(loading);
      if (!error) {
        setTotalPages(response?.totalDocs);
        setUser(response?.docs);
      }
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    fetchedGetUsers();
  }, [currentPage]);

  const handlePageChange = async (event) => {
    setCurrentPage(event?.selected + 1);
  };

  // Handle apply filter action
  const handleApplyFilter = () => {
    const trimmedFilterData = {
      ...filterData,
      keyword: filterData.keyword ? filterData.keyword.trim() : "",
    };
    fetchedGetUsers(trimmedFilterData);
  };

  const handleResetFilter = () => {
    setFilterData({});
    fetchedGetUsers();
  };

  return (
    <div className="right-panel p-3">
      <div class="common-heading text-start mb-3">
        <h4 className="mb-3 fw-bold fs-5 ">Member Manager </h4>
      </div>

      <div className="bg-white border text-start p-3 mb-4">
        <Row className="gx-2 align-item-center">
          <Col lg={3} md={4}>
            <Form.Control
              type="text"
              placeholder="Search..."
              name="keyword"
              value={filterData.keyword || ""}
              onChange={handleFilterChange}
              onInput={removeMultiSpace}
            />
          </Col>

          <Col lg={3} md={4} className="mt-lg-0 mt-3">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <Button
                  type="button"
                  className="bg-orange border-0 me-2 normal-size"
                  onClick={handleApplyFilter}
                >
                  Filter
                </Button>
                <Button
                  type="button"
                  className="bg-orange border-0 normal-size me-2"
                  onClick={handleResetFilter}
                >
                  Reset
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <section className="sponser-sec  pt-0 our-team-member pb-0 ">
        <div className="achiever-box gx-2 member-manager-cards d-flex flex-wrap">
          {loader ? (
            <Row className="achiever-box w-100">
              <Container className="d-flex justify-content-center align-items-center default-back">
                <span>
                  <LottiLoader height={120} width={120} loader={true} />
                </span>
              </Container>
            </Row>
          ) : (
            <>
              {user &&
                user.length > 0 &&
                user.map((item) => {
                  return (
                    <Col
                      lg={3}
                      md={4}
                      xs={6}
                      className="mb-3 box-member"
                      key={item?._id}
                    >
                      <Card className="sponser-cards speaker-box-layout2 position-relative">
                        <Figure>
                          <Card.Img
                            variant="top"
                            src={`${BASE_URL}/uploads/${item?.profilePic}`}
                            alt="Profile"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "https://static.vecteezy.com/system/resources/previews/022/014/063/original/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
                            }}
                          />
                        </Figure>
                        <Card.Body
                          className="text-start"
                          onClick={() => navigate(`/member-view/${item?._id}`)}
                        >
                          <Card.Title
                            className="fw-bold mb-1"
                            title={`${item?.firstName}
                             ${item?.lastName}`}
                          >
                            {`${item?.firstName} ${textTruncateMore(
                              item?.lastName,
                              7
                            )}`}
                          </Card.Title>
                          <Card.Text
                            style={{ color: "gray", fontSize: "14px" }}
                            className="mb-1"
                          >
                            {textTruncateMore(item?.email, 25) || ""}
                          </Card.Text>
                          {item?.mobile && (
                            <Card.Text
                              style={{ color: "gray", fontSize: "14px" }}
                              className="mb-0"
                            >
                              +91 {item?.mobile}
                            </Card.Text>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
            </>
          )}
        </div>
        {!loader && user && user?.length > 0 && (
          <OPagination
            pageCount={Math.ceil(totalPages / 10)}
            handlePageClick={(e) => handlePageChange(e)}
            page={currentPage}
          />
        )}

        {!loader && user?.length == 0 && (
          <NoDataFound height={200} width={200} firstMessage="No team found." />
        )}
      </section>
    </div>
  );
};

export default MemberInfo;
